export const APP_BUSY = 'APP_BUSY';
export const SIGN_IN = 'SIGN_IN';
export const USER = 'USER';

//
export const RESET = 'RESET';
export const SEARCH_RESULTS = 'SEARCH_RESULTS';
export const CREATE_24_BY_7 = 'CREATE_24_BY_7';
export const CREATE_SIBEL = 'CREATE_SIBEL';
